import {Organization} from '../../entity/model/organization';
import OrganizationStore from '../store/organization-store';

export default class OrganizationService {
  organizationStore: OrganizationStore;

  constructor(organizationStore: OrganizationStore) {
    this.organizationStore = organizationStore;
  }

  getOrganizations = async (currentOrganization?: string): Promise<Organization[]> => {
    const organizations = this.organizationStore.cache ? this.organizationStore.organizations : await this.organizationStore.getOrganizations();
    const testOrganizationPrefix = process.env.REACT_APP_TEST_ORGANIZATION_PREFIX;

    let testOrganizations: Organization[] = [];
    if (testOrganizationPrefix && testOrganizationPrefix !== '')
      testOrganizations = organizations.filter((organization: Organization) => organization.name.startsWith(testOrganizationPrefix));

    return currentOrganization && testOrganizations.find((organization: Organization) => organization.id === currentOrganization) === undefined
      ? organizations.filter((organization: Organization) => !testOrganizations.some((testOrganization: Organization) => testOrganization.id === organization.id))
      : organizations;
  }

  getOrganizationById = async (organizationId: string): Promise<Organization | undefined> => {
    return this.organizationStore.cache
      ? this.organizationStore.organizations.find((organization) => organization.id === organizationId)
      : this.organizationStore.getOrganizationById(organizationId);
  }
}